import { noop } from "lodash";

import { t } from "@/i18n-js/instance";

import type { PreviewComponents } from "../../../types";
import { Lines } from "../Lines";

export const onetimeVariants: PreviewComponents = [
  [
    Lines.TodayPaymentLine,
    () => ({
      label: t("paywall_checkout.todays_payment"),
    }),
  ],
  [Lines.SubtotalLine, noop],
  [Lines.DiscountLine, noop],
  [Lines.TaxLine, noop],
  [Lines.EndingBalanceLine, noop],
  [Lines.TotalDueTodayLine, noop],
];
